import React, { useState } from 'react';
import clazz from 'classnames';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { bodyScroll } from '@/shared/utils';
import './index.less';
export default function PictureGallery(props) {
    const { className, atlas = [], previewable = true } = props;
    const [photoIndex, setPhotoIndex] = useState(0);
    const [visible, updateVisible] = useState(false);
    const atlasLength = atlas.length;
    const openSwiper = (index) => {
        if (previewable) {
            setPhotoIndex(index);
            updateVisible(true);
            bodyScroll.forbidden();
        }
    };
    const closeSwiper = () => {
        updateVisible(false);
        setPhotoIndex(0);
        bodyScroll.can();
    };
    const genProgress = () => {
        return (<div className="picture-gallery-pagination">{`${+photoIndex +
            1}/${atlasLength}`}</div>);
    };
    return (<div className={clazz('picture-gallery', className)}>
      <div className="picture-gallery-preview">
        {atlas.map((atla, index) => (<div key={atla} className="picture-gallery-preview-item" onClick={() => openSwiper(index)} style={{ backgroundImage: `url(${atla})` }}>
            
          </div>))}
      </div>

      {previewable && visible && (<div className="picture-gallery-swiper-wrapper">
          <Lightbox wrapperClassName="picture-gallery-lightbox" clickOutsideToClose={false} mainSrc={atlas[photoIndex]} nextSrc={atlas[(photoIndex + 1) % atlasLength]} prevSrc={atlas[(photoIndex + atlasLength - 1) % atlasLength]} onCloseRequest={closeSwiper} onMovePrevRequest={() => setPhotoIndex((photoIndex + atlasLength - 1) % atlasLength)} onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % atlasLength)} imageCaption={genProgress()}/>
        </div>)}
    </div>);
}
